import logo from "../assets/logo/tivione-logo.jpg";
import visa from "../assets/logo/Visa.png";
import mastercard from "../assets/logo/Mastercard.png";
import paypal from "../assets/logo/Paypal.png";
import bancontact from "../assets/logo/Bancontact.png";
import ideal from "../assets/logo/ideal.svg";
import { CONTACT_CONFIG } from "../config/contact";
import GridTexture from "../components/GridTexture";

export default function Footer() {
  const { 
    phoneNumber: PHONE_NUMBER, 
    email: EMAIL, 
    whatsappUrl: WHATSAPP_URL, 
    companyName: COMPANY_NAME 
  } = CONTACT_CONFIG;
  return (
    <footer className="bg-surface-primary text-white relative overflow-hidden border-t border-line">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: "radial-gradient(circle, #00d4ff 1px, transparent 1px)",
            backgroundSize: "24px 24px",
          }}
        ></div>
      </div>
      <GridTexture />

      {/* Upper Section */}
      <div className="main-content w-[95%] sm:w-[90%] md:w-[85%] m-auto py-8 sm:py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 sm:gap-8">
          {/* Left Column - Logo and Description */}
          <div className="lg:col-span-1">
            <a
              href="/"
              className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4"
            >
              <img
                src={logo}
                alt="TiviOne logo"
                loading="lazy"
                className="footer-logo w-10 h-auto md:w-12 md:h-auto rounded-lg"
              />
              <span className="text-lg sm:text-xl font-bold text-white">
                {COMPANY_NAME}
              </span>
            </a>
            <p className="text-ink-secondary leading-relaxed text-sm sm:text-base">
              Wij bieden de beste IPTV-diensten. Onze service is
              eenvoudig, snel en betrouwbaar. Geniet van je favoriete
              zenders op elk apparaat, waar je ook bent.
            </p>
          </div>

          {/* Middle Column - Quick Links */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">
              Snelle Links
            </h3>
            <div className="w-10 sm:w-12 h-1 bg-accent mb-3 sm:mb-4"></div>
            <ul className="space-y-1.5 sm:space-y-2 mb-5 sm:mb-6">
              <li>
                <a
                  href="/#films"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  Zenders &amp; Films
                </a>
              </li>
              <li>
                <a
                  href="/#sport"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  Sport
                </a>
              </li>
              <li>
                <a
                  href="/#pricing"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  Pakketten
                </a>
              </li>
              <li>
                <a
                  href="/#faq"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  Veelgestelde Vragen
                </a>
              </li>
            </ul>
            <ul className="space-y-1.5 sm:space-y-2 pt-4 border-t border-line">
              <li>
                <a
                  href="/refundpolicy"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  Restitutiebeleid
                </a>
              </li>
              <li>
                <a
                  href="/privacypolicy"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  Privacybeleid
                </a>
              </li>
              <li>
                <a
                  href="/termsandconditions"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  Algemene Voorwaarden
                </a>
              </li>
            </ul>
          </div>

          {/* IPTV Gids Column */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">
              IPTV Gids
            </h3>
            <div className="w-10 sm:w-12 h-1 bg-accent mb-3 sm:mb-4"></div>
            <ul className="space-y-1.5 sm:space-y-2">
              <li>
                <a
                  href="/wat-is-iptv"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  Wat is IPTV?
                </a>
              </li>
              <li>
                <a
                  href="/iptv-nederland"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  IPTV Nederland
                </a>
              </li>
              <li>
                <a
                  href="/iptv-belgie"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  IPTV België
                </a>
              </li>
              <li>
                <a
                  href="/iptv-installeren"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  IPTV Installeren
                </a>
              </li>
              <li>
                <a
                  href="/iptv-gids"
                  className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base"
                >
                  Volledige IPTV Gids
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">
              Contact
            </h3>
            <div className="w-10 sm:w-12 h-1 bg-accent mb-3 sm:mb-4"></div>
            <div className="space-y-2 sm:space-y-3">
              <div className="flex items-center gap-2 sm:gap-3">
                <svg
                  className="text-accent w-4 h-4 sm:w-5 sm:h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <span className="text-ink-secondary text-sm sm:text-base">
                  {EMAIL}
                </span>
              </div>
              <div className="flex items-center gap-2 sm:gap-3">
                <svg
                  className="text-accent w-4 h-4 sm:w-5 sm:h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <span className="text-ink-secondary hover:text-accent transition-colors duration-300 text-sm sm:text-base">
                  <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-accent"
                  >
                    {PHONE_NUMBER}
                  </a>
                </span>
              </div>
            </div>
          </div>

          {/* Right Column - Payment Methods */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">
              Wij accepteren
            </h3>
            <div className="w-10 sm:w-12 h-1 bg-accent mb-3 sm:mb-4"></div>
            <div className="grid grid-cols-3 gap-2">
              <div className="bg-white rounded-md sm:rounded-lg p-1.5 sm:p-2 flex items-center justify-center border border-white/10 hover:border-accent/40 transition-all duration-300">
                <img
                  src={ideal}
                  alt="iDEAL"
                  loading="lazy"
                  className="h-6 sm:h-8 w-auto"
                />
              </div>
              <div className="bg-white rounded-md sm:rounded-lg p-1.5 sm:p-2 flex items-center justify-center border border-white/10 hover:border-accent/40 transition-all duration-300">
                <img
                  src={paypal}
                  alt="PayPal"
                  loading="lazy"
                  className="h-6 sm:h-9 w-auto"
                />
              </div>
              <div className="bg-white rounded-md sm:rounded-lg p-1.5 sm:p-2 flex items-center justify-center border border-white/10 hover:border-accent/40 transition-all duration-300">
                <img
                  src={visa}
                  alt="VISA"
                  loading="lazy"
                  className="h-3 sm:h-4 w-auto"
                />
              </div>
              <div className="bg-white rounded-md sm:rounded-lg p-1.5 sm:p-2 flex items-center justify-center border border-white/10 hover:border-accent/40 transition-all duration-300">
                <img
                  src={mastercard}
                  alt="MasterCard"
                  loading="lazy"
                  className="h-4 sm:h-6 w-auto"
                />
              </div>
              <div className="bg-white rounded-md sm:rounded-lg p-1.5 sm:p-2 flex items-center justify-center border border-white/10 hover:border-accent/40 transition-all duration-300">
                <img
                  src={bancontact}
                  alt="Bancontact"
                  loading="lazy"
                  className="h-4 sm:h-6 w-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lower Section - Bottom Bar */}
      <div className="border-t border-line">
        <div className="main-content py-3 sm:py-4">
          <div className="text-xs sm:text-sm text-center text-ink-muted mb-1 sm:mb-2 md:mb-0">
            © {COMPANY_NAME} - {EMAIL}
          </div>
        </div>
      </div>
    </footer>
  );
}
